import { useMemo } from 'react'
import s from './index.module.scss'

interface P {
  visible: boolean
  setVisible: (visible: boolean) => void
}
function Home(props: P) {
  const { setVisible } = props
  return useMemo(() => {
    return (
      <div
        className={s.mask}
        onClick={() => {
          setVisible(false)
        }}
      >
        <div className={s.icon} />
      </div>
    )
  }, [setVisible])
}

export default Home
